import React, { useRef } from "react";
import PropTypes from "prop-types";
import { useOutsideClick } from "../../utils/useOutsideClick";

import imgClose from "../../images/common/close-dark.svg";

const FormInfoPopup = ({ info, close }) => {
  const popupRef = useRef();

  useOutsideClick(popupRef, () => close());

  return (
    <div className="FormInfoPopup">
      <div ref={popupRef} className="FormInfoPopup__popup">
        <button className="FormInfoPopup__close" onClick={close}>
          <img src={imgClose} alt="close" />
        </button>

        <p>{info}</p>
      </div>
    </div>
  );
};

FormInfoPopup.propTypes = {
  info: PropTypes.string.isRequired,
  close: PropTypes.func.isRequired
};

export default FormInfoPopup;
